/**
 * @param {Badge} badge
 * @returns {boolean}
 */
const _isFauxOffer = (badge) => badge?.header?.includes('coupon excluded');

/**
 * @param {Badge} badge
 * @returns {string}
 */
const _hasPromo = (badge) => badge.promoCode;

/**
 * @param {Badge []} badges
 * @returns {Badge}
 */
export const perksPromotion = (badges) => badges.filter(_isFauxOffer)[0];

/**
 * @param {Badge []} badges
 * @returns {Badge[]}
 */
export const buildPerksPromotions = (badges) => badges.filter((badge) => {
  if (_isFauxOffer(badge)) return false;
  return !_hasPromo(badge);
});
